export default __webpack_public_path__ + "static/media/ResultsOff.62914c89.svg";